import { render, staticRenderFns } from "./erActionButton.vue?vue&type=template&id=275489c0&"
import script from "./erActionButton.vue?vue&type=script&lang=js&"
export * from "./erActionButton.vue?vue&type=script&lang=js&"
import style0 from "./erActionButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports